export default filterArray => {
  return filterArray.filter(value => value !== undefined).join(", ");
};
